module.exports = __webpack_public_path__ + "img/maneken_pos_4_back.e384b92c.png";